import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { clone, cloneDeep, get, isEmpty, omit, values } from "lodash";
import constants from "../../utils/constants";
import { customRegexValidation, mobNumberRegex, specialRegexValidation, startCharCheckValidation, validateFields, whiteSpaceValidation } from "../../utils/regexValidation";
import addEditPatient from "../AddEditPatient/services/addEditPatient";
import Toast from "../Toast";
import mwl from "../../utils/mwl";
import Store from "../../utils/Store";
import { defaultFormData } from "./utils";
import { generatePatientId, getGender, isIOSWebView, isNonDicomFile } from "../../utils";
import { trackEvent } from "../../utils/mixpanel";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { useRouter } from "next/router";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { format } from "date-fns";
import PatientForm from "../PatientRegistration/PatientForm";
import getEnv from "../../utils/getEnv";
import { patientFullDisplayName, patientPrimaryName } from "../../utils/patientFormName";
function RegistrationForm(_ref) {
  var selectedSource = _ref.selectedSource,
    setSelectedFiles = _ref.setSelectedFiles,
    patient = _ref.patient,
    setPatient = _ref.setPatient,
    isSinglePatient = _ref.isSinglePatient,
    onUpload = _ref.onUpload,
    selectedFiles = _ref.selectedFiles,
    closePopup = _ref.closePopup,
    onConfirmUpload = _ref.onConfirmUpload,
    selectedFilesKeys = _ref.selectedFilesKeys,
    formattedSelectedFiles = _ref.formattedSelectedFiles,
    isUploadInProgress = _ref.isUploadInProgress,
    showLoading = _ref.showLoading,
    onAddFile = _ref.onAddFile,
    isEdited = _ref.isEdited,
    setIsEdited = _ref.setIsEdited,
    checkedFilesLength = _ref.checkedFilesLength,
    setIsGuidelineModal = _ref.setIsGuidelineModal,
    hasCurrentPatient = _ref.hasCurrentPatient;
  var router = useRouter();
  var _useState = useState(""),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var hasNewFieldsInForm = getEnv("NEXT_PUBLIC_ADD_FIELDS_IN_REGISTRATION_FORM") === "true";
  var DISABLE_MWL_CALL = String(getEnv("NEXT_PUBLIC_DISABLE_MWL_CALL")) === "true";
  var hasDefaultPatientId = getEnv("NEXT_PUBLIC_GENERATE_PATIENT_ID_ENABELED") === "true";
  var IS_MWL_ENABLED = String(getEnv("NEXT_PUBLIC_IS_MWL_ENABLED")) === "true";
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var requiredKey = hasNewFieldsInForm ? omit(patient, ["patient_id", "patient_uid"]) : omit(patient, ["patient_id", "patient_uid", "contact", "dob", "relative_name"]);
  var buildPayload = function buildPayload() {
    var _patient = clone(patient);
    if (!_patient.patient_uid) {
      delete _patient.patient_uid;
    }
    var combinedName = patientFullDisplayName(patient);
    if (combinedName) {
      _patient.name = combinedName;
    }
    if (patient !== null && patient !== void 0 && patient.dob) {
      var dob = new Date(patient.dob);
      if (!isNaN(dob.getTime())) {
        _patient.dob = format(dob, "yyyy-MM-dd");
      }
    }
    return _patient;
  };
  useEffect(function () {
    if (hasDefaultPatientId) {
      var _patient = clone(patient);
      _patient.patient_id = generatePatientId();
      setPatient(_patient);
    }
  }, [hasDefaultPatientId]);
  var validateForm = function validateForm() {
    var age = patient.age,
      gender = patient.gender;
    var _error = "";
    var errMsg = "Please enter";
    if (isEmpty(selectedFiles)) {
      if (!patientPrimaryName(patient)) {
        _error += " Full name,";
      }
      var ageMissing = age === undefined || age === null || age === "" || typeof age !== "number" && String(age).trim() === "";
      if (ageMissing) {
        _error += " Age,";
      }
      if (gender === "") {
        _error += " Gender,";
      }
      if (isEmpty(selectedSource)) {
        _error += " Workspace,";
      }
    }
    if (_error) {
      _error = (errMsg + _error).slice(0, -1);
      setError(_error);
      return false;
    }
    return true;
  };
  var onCloseModal = function onCloseModal() {
    setPatient(defaultFormData);
    setSelectedFiles({});
    setError("");
    if (!isMobile) {
      Store.update(function (s) {
        s.uploadModal = {
          isOpen: false,
          hasCurrentPatient: false
        };
      });
    } else if (isIOSWebView()) {
      router.back();
    } else {
      router.push("/patients");
    }
  };
  var setMetaData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fileObj) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, new Promise(function (resolve) {
              var _getGender$shortLabel, _getGender;
              var _isNonDicomFile = isNonDicomFile(get(fileObj, ["file", "type"]));
              var res = _objectSpread(_objectSpread({}, fileObj), {}, {
                metaData: _objectSpread(_objectSpread({}, fileObj.metaData), {}, {
                  PatientAge: "".concat(patient === null || patient === void 0 ? void 0 : patient.age, "Y"),
                  PatientName: patientFullDisplayName(patient),
                  PatientGender: (_getGender$shortLabel = (_getGender = getGender(parseInt(patient === null || patient === void 0 ? void 0 : patient.gender))) === null || _getGender === void 0 ? void 0 : _getGender.shortLabel) !== null && _getGender$shortLabel !== void 0 ? _getGender$shortLabel : "",
                  PatientID: patient === null || patient === void 0 ? void 0 : patient.patient_id,
                  Contact: patient === null || patient === void 0 ? void 0 : patient.contact
                })
              });
              if (!_isNonDicomFile) {
                res.anonymize_dicom_metadata = true;
              }
              var inValidFilters = constants.REQUIRED_DICOM_METADATA.filter(function (field) {
                return isEmpty(get(res, ["metaData", field], ""));
              });
              var isValid = isEmpty(inValidFilters);
              if (!isValid) {
                res.inValidMessage = "".concat(t("missing_metadata"), ": ").concat(inValidFilters.join(", "));
              }
              return resolve(res);
            }));
        }
      }, _callee);
    }));
    return function setMetaData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onEditData = function onEditData() {
    var filesArray = values(selectedFiles).map(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fileObj) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return setMetaData(fileObj);
            case 1:
              return _context2.a(2, _context2.v);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    Promise.all(filesArray).then(function (response) {
      var fin_obj = {};
      response.map(function (item) {
        return fin_obj[item.fileKey] = item;
      });
      var cloneSelectedFiles = values(cloneDeep(fin_obj)).filter(function (fileObj) {
        return fileObj.isSelected;
      }).reduce(function (acc, file) {
        acc[file.fileKey] = file;
        return acc;
      }, {});
      onConfirmUpload(cloneSelectedFiles);
      closePopup();
    });
  };
  var onRegister = function onRegister(e) {
    e === null || e === void 0 || e.preventDefault();
    var validationResults = validateFields([{
      fn: customRegexValidation,
      value: patientFullDisplayName(patient),
      err: " ".concat(t("add_patient_modal.validation.name_special_char"), ",")
    }, {
      fn: startCharCheckValidation,
      value: patientFullDisplayName(patient),
      err: " ".concat(t("add_patient_modal.validation.name_start"), ",")
    }, {
      fn: whiteSpaceValidation,
      value: patient.patient_id,
      err: " ".concat(t("add_patient_modal.validation.id_space"), ",")
    }, {
      fn: specialRegexValidation,
      value: patient.patient_id,
      err: " ".concat(t("add_patient_modal.validation.id_alphanumeric_char"), ",")
    }, {
      fn: mobNumberRegex,
      value: patient.contact,
      err: " ".concat(t("add_patient_modal.validation.mobile_number"), ",")
    }]);
    if (validationResults) {
      setError(validationResults);
    }
    if (validateForm() && !validationResults) {
      setError("");
      var patientObj = buildPayload();
      var sourceId = get(selectedSource, ["id"], "");
      if (!isEmpty(selectedFiles)) {
        if (!isEdited) {
          onUpload();
        } else {
          onEditData();
        }
      } else {
        var _patientObj$additiona2;
        setLoading(true);
        Store.update(function (s) {
          s.newPatientId = patientObj === null || patientObj === void 0 ? void 0 : patientObj.patient_id;
        });
        if (IS_MWL_ENABLED && !DISABLE_MWL_CALL) {
          var _patientObj$additiona;
          // update initial state of patient to registered
          patientObj.additional = (_patientObj$additiona = patientObj.additional) !== null && _patientObj$additiona !== void 0 ? _patientObj$additiona : {};
          patientObj.additional.mpps_progress = constants.MPPS_STATUS.REGISTERED;
        }
        var patientPayload = clone(patientObj);
        if ((_patientObj$additiona2 = patientObj.additional) !== null && _patientObj$additiona2 !== void 0 && _patientObj$additiona2.patient_name) {
          var _ref4, _patientObj$additiona3;
          patientPayload.first_name = (_ref4 = (_patientObj$additiona3 = patientObj.additional.patient_name.first) !== null && _patientObj$additiona3 !== void 0 ? _patientObj$additiona3 : patient.name) !== null && _ref4 !== void 0 ? _ref4 : "";
          patientPayload.middle_name = patientObj.additional.patient_name.middle || "";
          patientPayload.last_name = patientObj.additional.patient_name.last || "";
        }
        addEditPatient(patientPayload, false, sourceId).then(function (response) {
          if ((response === null || response === void 0 ? void 0 : response.status) === 208) {
            Toast.error(t("register.toast.patient_existed"));
          } else {
            Toast.success(t("register.toast.success_message"));
            var event = MIXPANEL_EVENTS.SUBMIT_ADD_PATIENT;
            var params = {
              patient_uid: get(response, ["data", "data", "patient_uid"], 0)
            };
            if (get(patientObj, ["patient_uid"], "")) {
              event = MIXPANEL_EVENTS.SUBMIT_EDIT_PATIENT;
              params = {
                patient_uid: get(patientObj, ["patient_uid"], "")
              };
            }
            trackEvent(event, params);
          }
          // update the record in mwl
          // should be behind a feature flag
          if (IS_MWL_ENABLED && !DISABLE_MWL_CALL) {
            mwl.upsertRecord(false, patientObj, get(response, ["data", "data", "patient_uid"], 0), get(response, ["data", "data", "patient_id"], 0));
          }
          setLoading(false);
          onCloseModal();
        })["catch"](function () {
          Store.update(function (s) {
            s.newPatientId = "";
          });
          setError(t("register.toast.error_message"));
          setLoading(false);
        });
      }
    }
  };
  useEffect(function () {
    // track form opening event
    if (!hasCurrentPatient) {
      trackEvent(MIXPANEL_EVENTS.OPEN_ADD_PATIENT);
    }
  }, [hasCurrentPatient]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PatientForm, {
    onRegister: onRegister,
    patient: patient,
    setPatient: setPatient,
    isLoading: isLoading,
    error: error,
    hasNewFieldsInForm: hasNewFieldsInForm,
    selectedFiles: selectedFiles,
    checkedFilesLength: checkedFilesLength,
    requiredKey: requiredKey,
    isUploadInProgress: isUploadInProgress,
    showLoading: showLoading,
    isSinglePatient: isSinglePatient,
    selectedFilesKeys: selectedFilesKeys,
    formattedSelectedFiles: formattedSelectedFiles,
    setIsEdited: setIsEdited,
    onAddFile: onAddFile,
    setIsGuidelineModal: setIsGuidelineModal
  }));
}
export default RegistrationForm;